export default "__VITE_ASSET__ChH_5nWE__"